import { Link, useNavigate } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const CleanupLink = ({ to, children, className, onClick, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    
    // Call any passed-in onClick handler first
    if (onClick) onClick(e);

    // Kill all ScrollTriggers and unpin everything
    ScrollTrigger.getAll().forEach(st => {
      st.kill(true);
    });
    
    // Small delay to ensure cleanup completes
    setTimeout(() => {
      navigate(to);
    }, 50);
  };

  return (
    <Link to={to} onClick={handleClick} className={className} {...props}>
      {children}
    </Link>
  );
};

export default CleanupLink;